import axios      from 'axios';
import authHeader from 'services/auth-header';

class UserService  {
  profile(id) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'doctors/' + id + '/profile', { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }
  marketingEmail(id, enabled){
    return axios
    .patch(process.env.REACT_APP_API_ENDPOINT + 'doctors/' + id + '/marketing_email', {marketing_email_enabled: enabled}, {headers: authHeader()})
    .then(response => {
      return response.data;
      }
    );
  }
  submitProfileChangeRequest(payload){
    return axios
    .post(process.env.REACT_APP_API_ENDPOINT + 'profile_change_requests', payload, {headers: authHeader()})
    .then(response => {
      return response.data;
    });
  }
  reminderSettings(payload){
    return axios
    .post(process.env.REACT_APP_API_ENDPOINT + 'reminder_settings', payload, {headers: authHeader()})
    .then(response => {
      return response.data;
    });
  }
  changePassword(payload){
    return axios
    .put(process.env.REACT_APP_API_ENDPOINT + 'doctors/password', payload, {headers: authHeader()})
    .then(response => {
      return response.data;
    });
  }
  getLanguages(){
    return axios
    .get(process.env.REACT_APP_API_ENDPOINT + 'languages', {headers: authHeader() })
    .then(response => {
      return response.data;
    });
  }
  toggleTeleconsult(id, enabled){
    return axios
    .put(process.env.REACT_APP_API_ENDPOINT + 'doctors/' + id + '/toggle_teleconsult', {teleconsult_enabled: enabled}, {headers: authHeader()})
    .then(response => {
      return response.data;
    });
  }
  updateRecipientsEmails(email_array){
    return axios
    .post(process.env.REACT_APP_API_ENDPOINT + 'doctors/update_recipients_emails', { recipients_emails: email_array}, {headers: authHeader()})
    .then(response => {
      return response.data;
    });
  }
  getSpecialties() {
    return axios
    .get(process.env.REACT_APP_API_ENDPOINT + 'specialties', { headers: authHeader() })
    .then(response => {
      return response.data;
    });
  }
}

export default new UserService();